import React from 'react';

export class ToggleClosed extends React.Component {
   render() {
      return <div className='neo-icon-chat'></div>;
   }
};
